import { useLayoutEffect } from 'react';

import { ColorScheme } from '../RCThemeContext/RCThemeContext';

export function useColorScheme(callback: (colorScheme: ColorScheme) => void) {
  useLayoutEffect(() => {
    const isSupported = !!window && window.matchMedia && window.addEventListener;
    if (!isSupported) return;

    const query = window.matchMedia('(prefers-color-scheme: dark)');

    function handleChange(event: MediaQueryListEvent) {
      const colorScheme = event.matches ? 'dark' : 'light';
      callback(colorScheme);
    }

    query.addEventListener('change', handleChange);

    return () => {
      query.removeEventListener('change', handleChange);
    };
  }, [callback]);
}
